














import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component<CBooleanSwitch>({})
export default class CBooleanSwitch extends Vue {
  @Prop({ type: Boolean, required: true })
  value: boolean;

  @Prop({ type: String, required: true })
  onLabel: string;

  @Prop({ type: String, required: true })
  offLabel: string;

  get offLabelClass(): string {
    let classes = 'mr-3 font-weight-bold text-uppercase';
    if (this.value) {
      classes += ' grey--text';
    }
    return classes;
  }

  get onLabelClass(): string {
    let classes = 'ml-2 font-weight-bold text-uppercase';
    if (this.value) {
      classes += ' orange--text darken-1';
    } else {
      classes += ' grey--text';
    }
    return classes;
  }
}
